<div class="tw-flex tw-flex-1 tw-flex-col tw-min-h-0" id="sidebar">
  <div class="sidebar-header border-bottom-2px tw-box-border tw-flex tw-h-[80px] tw-shrink-0 tw-p-6">
    <div class="tw-w-[30px] tw-shrink-0"></div>
    <div class="tw-flex tw-flex-1 tw-items-center tw-justify-center">
      <h3>{{ sidebarHeader }}</h3>
    </div>
    <div class="tw-flex tw-w-[30px] tw-shrink-0 tw-items-center tw-justify-center">
      <ate-icon
        (click)="closeSidebar()"
        class="close link-item close-icon"
        matTooltip="Close"
        matTooltipPosition="above"
        name="cancel"
        data-cy="btn-close-sidebar"></ate-icon>
    </div>
  </div>
  <div class="sidebar-content tw-flex tw-flex-1 tw-flex-col tw-min-h-0">
    <marketplace-filters class="h100"></marketplace-filters>
  </div>
</div>
